<template lang="pug">
  div.AK-Filter
    div.AK-Filter_Title 希望エリアで絞り込み：
    select.AK-Filter_Select.form-Control(v-model="area", @change="handleChange")
      option(value="" selected) 全国
      option(v-for="a in areas", :key="a", :value="a") {{a}}
</template>
<script>
  export default {
    data() {
      return {
        area: '',
        areas: [
          '北海道',
          '東北',
          '関東',
          '中部',
          '近畿',
          '中国',
          '四国',
          '九州・沖縄',
        ],
      };
    },
    methods: {
      handleChange(e) {
        this.$emit('change', e.target.value);
      },
    },
  };
</script>
